import type { GetDeteriorationModelAssetsResultsPaginatedRequests } from '@Types/deteriorationModels.types';

/**
 * The asset results query used until the user sorts, filters or pages: worst failure
 * probability first. The page, AssetsResults and the pagination reducer each had their
 * own copy, and two of them sorted by asset ID. When the page's request raced
 * AssetsResults' (after a run, with nothing saved), the page's won, and the grid
 * showed asset-ID order under a "failure probability" sort header.
 */
export const getDefaultAssetsResultsRequest = (
	modelId: string,
	runId: string,
): GetDeteriorationModelAssetsResultsPaginatedRequests => ({
	modelId,
	runId,
	page: 1,
	slice: 10,
	sortKey: 'failureProbability',
	sortDescending: true,
	searchValue: null,
	filter: null,
	filterModel: { items: [] },
});
